import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TableOrderingContext } from '../types/tableOrdering';
import { 
  parseContextFromURL, 
  saveContextToSession, 
  loadContextFromSession, 
  clearContextFromSession 
} from '../utils/parseTableContext';

/**
 * Custom hook to manage table ordering context with session persistence
 */
export const useTableContext = () => {
  const [searchParams] = useSearchParams();
  const [context, setContext] = useState<TableOrderingContext | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const parsedContext = parseContextFromURL(searchParams);
    setContext(parsedContext);
    setIsLoading(false);
  }, [searchParams]);

  const updateContext = (newContext: TableOrderingContext) => {
    setContext(newContext);
    saveContextToSession(newContext);
  };

  const clearContext = () => {
    setContext(null);
    clearContextFromSession();
  };

  const refreshFromSession = () => {
    const sessionContext = loadContextFromSession();
    setContext(sessionContext);
    return sessionContext;
  };

  return {
    context,
    isLoading,
    updateContext,
    clearContext,
    refreshFromSession,
    hasContext: !!context
  };
};